import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Sets the `}<a parentName="p" {...{
        "href": "https://developers.google.com/pay/api/android/guides/tutorial#supported-card-networks"
      }}>{`card networks`}</a>{` that your application accepts.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      